//DSS Documentation on Validation - http://tiny.sc/cgvalidation
export class Sample {
    id: number = 0;
    description: string = '';
    lastModified: Date = new Date();
}
